import forget from './forget'

export { forget }